import React from 'react';

import { ThemeProvider } from 'styled-components';

import {
  createTheme,
  ThemeProvider as ThemeMaterialUI,
} from '@material-ui/core/styles';
import { ptBR } from '@material-ui/core/locale';
import { Router } from 'react-router-dom';
import GlobalStyles from '~/styles/global';

import Routes from '~/routes';
import theme from '~/styles/theme';
import { AuthProvider } from './context/auth';
import { LojaProvider } from './context/loja';
import history from './services/history';
import { QueryClientProvider, QueryClient } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';
import { ToastContainer } from 'react-toastify';

import 'react-toastify/dist/ReactToastify.css';
import 'tippy.js/dist/tippy.css';
import 'tippy.js/animations/scale.css';

import { injectStyle } from 'react-toastify/dist/inject-style';
import { NavbarProvider } from './context/navbar';
import { initClarity } from './utils/initClarity';
import EncerramentoSistema from './components/EncerramentoSistema';

injectStyle();
initClarity();

const queryClient = new QueryClient();

function App(): JSX.Element {
  const themeMaterial = createTheme({}, ptBR);

  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider theme={theme}>
        <ThemeMaterialUI theme={themeMaterial}>
          <LojaProvider>
            <AuthProvider>
              <NavbarProvider>
                <EncerramentoSistema>
                  <Router history={history}>
                    <Routes />
                  </Router>
                </EncerramentoSistema>
                <GlobalStyles />
                <ToastContainer
                  position="bottom-right"
                  autoClose={5000}
                  hideProgressBar={false}
                  newestOnTop={false}
                  closeOnClick
                  rtl={false}
                  pauseOnFocusLoss
                  draggable
                  pauseOnHover
                />
              </NavbarProvider>
            </AuthProvider>
          </LojaProvider>
        </ThemeMaterialUI>
      </ThemeProvider>
      <ReactQueryDevtools />
    </QueryClientProvider>
  );
}

export default App;
